<template>
  <div class="nopic">
    <div>
      <img width="80%"
           v-if="isSimple"
           src="@/assets/uploader/emptyImage.png"
           alt="">
      <img width="80%"
           v-else
           src="@/assets/uploader/withoutpic.png"
           alt="">
      <!-- :src="isSimple?'@/assets/uploader/emptyImage.png':'@/assets/uploader/withoutpic.png'" -->
      <!-- src="@/assets/uploader/emptyImage.png" -->
      <p>您还未上传任何图片哦~</p>
      <p style="font-size:2.6vw;margin-top:2vw">部分安卓机型图片只能单选哦~</p>
      <van-button @click="openClick"
                  :disabled="isClock"
                  round
                  style="width:58.933vw;height:12vw;font-size:5vw;margin-top: 12.667vw;"
                  type="info"
                  :color="isSimple?'#F65D27':'#185ED3'">添加图片</van-button>
    </div>
  </div>
</template>

<script>
// import { disableBrowserBack } from "@/plugins/util";
import { createStore } from "@/store";
const store = createStore();
export default {
  data () {
    return {
      isClock: false
    }
  },
  methods: {
    openClick () {
      if (!this.isClock) {
        this.$router.push({
          path: '/uploader',
          query: {
            token: store.state.user.token,
            date: store.state.user.expirationTime,
            createUid: store.state.user.createUid,
            powers: JSON.stringify(store.state.user.powers)
          }
        })
      }
    },
  },
  created () {
    // localStorage.setItem('token', this.$route.query.token)
    // localStorage.setItem('createUid', this.$route.query.createUid)
    if (this.$route.params.isClock) {
      this.isClock = true
    } else {
      this.isClock = false
    }
  },
  mounted () {
    // disableBrowserBack()
  }
}
</script>

<style lang="scss" scoped>
@import "./nopic.scss";
</style>